import React from 'react';
import { NavLink } from 'react-router-dom';
import './NavPane.scss';
import VersionDropdown from 'src/components/VersionDropdown';
import routes from 'src/routes';

function Link({
    children, ...otherProps
}) {
    return <NavLink className="nav-row" {...otherProps}>{children}</NavLink>;
}

function NavPane() {
    return <div className='nav-pane'>
        <VersionDropdown />
        <ul>
            <li>
                <Link end to={routes.root}>Home</Link>
            </li>
            <li>
                <div className="nav-row">Getting started</div>
                <ul>
                    <li>
                        <Link end to={routes.getstarted.quickstart}>QuickStart</Link>
                        <Link end to={routes.getstarted.openapigenerator}>OpenAPI Generator</Link>
                        <Link end to={routes.reference.testMode}>Test mode transactions</Link>
                    </li>
                </ul>
            </li>            
            <li>
                <div className="nav-row">API</div>
                <ul>
                    <li>
                        <Link end to={routes.api.root}>Introduction</Link>
                    </li>
                    <li>
                        <Link end to={routes.api.txn.authkey.overview}>Overview</Link>
                    </li>
                    <li>
                        <Link end to={routes.api.txn.authkey.gettingStarted}>Getting started</Link>
                    </li>
                    <li>
                        <Link end to={routes.api.spec}>Specification</Link>
                    </li>
                    <li>
                        <Link end to={routes.api.batch.root}>Batch</Link>                        
                    </li>
                    <li>
                        <Link end to={routes.api.biller.root}>Biller</Link>                        
                    </li>
                    <li>
                        <Link end to={routes.api.paymentRequest.root}>Payment request</Link>
                    </li>
                    <li>
                        <Link end to={routes.api.reporting.root}>Reporting</Link>                        
                    </li>
                    <li>
                        <div className="nav-row">Transaction processing</div>
                        <ul>                           
                            
                            <li><Link end to={routes.api.txn.authkey.flow}>Transaction flow</Link></li>
                            <li>
                                <p>
                                    <div className="nav-row">Authentication (3D Secure)</div>
                                    <ul>
                                        <li><Link end to={routes.api.ThreeDSecure}>Overview</Link></li>
                                        <li><Link end to={routes.api.txn.authkey.authentication}>Integrate authentication</Link></li>
                                        <li><Link end to={routes.reference.threeds}>Response codes</Link></li>
                                    </ul>
                                </p>
                            </li>
                            <li><Link end to={routes.api.txn.authkey.javascriptSimple}>JavaScript - Simple</Link></li>
                            <li><Link end to={routes.api.txn.authkey.javascriptAdvanced}>JavaScript - Advanced</Link></li>
                            <li><Link end to={routes.api.txn.authkey.iframeFields}>Iframe Fields</Link></li>
                            <li><Link end to={routes.api.twoparty.root}>2-party</Link></li>
                            <li><Link end to={routes.api.twoPartyTxnProcessing.root}>2-party AuthKey</Link></li>                            
                            <li><Link end to={routes.api.txn.authkey.hpp}>HPP Configuration</Link></li>
                            <li><Link end to={routes.api.txn.authkey.klarna}>Klarna</Link></li>
                            <li><Link end to={routes.api.txn.authkey.applepay}>Apple Pay</Link></li>
                            <li><Link end to={routes.api.txn.authkey.googlepay}>Google Pay</Link></li>
                            <li><Link end to={routes.api.txn.authkey.avs}>Address Verification Service</Link></li>
                        </ul>
                    </li>
                    <li>
                        <div className="nav-row">Token management</div>
                        <ul>                            
                            <li><Link end to={routes.api.token.authkey.flow}>Token flow</Link></li>
                            <li><Link end to={routes.api.twopartytoken.root}>2-party</Link></li>
                            <li><Link end to={routes.api.twoPartyTokenProcessing.root}>2-party AuthKey</Link></li>
                            <li><Link end to={routes.api.token.authkey.javascriptSimple}>JavaScript - Simple</Link></li>
                            <li><Link end to={routes.api.token.authkey.javascriptAdvanced}>JavaScript - Advanced</Link></li>
                            <li><Link end to={routes.api.token.authkey.iframeFields}>Iframe Fields</Link></li>                            
                        </ul>
                    </li>
                    <li>
                        <Link end to={routes.api.webhooks}>Webhooks</Link>
                    </li>
                </ul>
            </li>
            <li>
                <div className="nav-row">Plugins</div>
                <ul>
                    <li>
                        <Link end to={routes.plugins.root}>Plugins</Link>
                    </li>
                </ul>
            </li>
            <li>
                <div className="nav-row">References</div>
                <ul>
                    <li>
                        <Link end to={routes.reference.bankResponseCodes}>Bank response codes</Link>
                    </li>
                    <li>
                        <Link end to={routes.reference.avsResultCodes}>AVS result codes</Link>
                    </li>
                    <li>
                        <Link end to={routes.reference.countryCodes}>Country codes</Link>
                    </li>
                    <li>
                        <Link end to={routes.reference.currencyCodes}>Currency codes</Link>
                    </li>
                </ul>
            </li>
        </ul>
    </div>;
}

export default NavPane;